import { Payload } from "@neworbit/redux-helpers";

import { ConsultationDetails } from "@teamprevent/common/consultations/models";

import * as actions from "./actionTypes";

export type ConsultationLoadedSuccess = ({ type: typeof actions.CONSULTATION_LOAD_SUCCESS }) & Payload<ConsultationDetails>;

export function consultationLoaded(payload: ConsultationDetails): ConsultationLoadedSuccess {
    return {
        type: actions.CONSULTATION_LOAD_SUCCESS,
        payload
    };
}
